module.exports = __webpack_public_path__ + "944d185b6f9deee6b6ac6bc3d1274499.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-1024.webp
// module id = 405
// module chunks = 0